import React, { useEffect, useState } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { faCaretDown, faDownload, faLock, faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Menu, Modal, Popconfirm, Row, message } from 'antd';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { observer } from 'mobx-react';
import moment from 'moment';
import Router from 'next/router';
import { DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED, PROJECT_STATUS_DISPLAY } from '@gtintel/platform-constants';
import { useStores } from '@gtintel/platform-stores';
import { RouteRolesEnum } from '@gtintel/platform-types';
import CloseProjectModal from '../CloseProjectModal';
import PreviewPDF from '../PreviewPDF';
import CheckIcon from './check';
import MenuCloseButton from './components/MenuCloseButton';
import MenuDeleteButton from './components/MenuDeleteButton';
import { ClosedButtons, CopyButtons } from './styles';
import styles from './styles.module.scss';
function formatClosedDate(closeDate) {
  return moment(closeDate).isValid() ? moment(closeDate).add(DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED, 'days').format('LL') : moment().add(DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED, 'days').format('LL');
}
const ActionButtons = props => {
  const {
    changeProjectStatus,
    changeStatusToActivated,
    confirm,
    createSubProject,
    showAccountingModal,
    showEditProjectModal
  } = props;
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    projectDetail,
    projectReports,
    isUpdateSuccess,
    isLoading
  } = adminProjectDetailStore;
  const [isShowPreviewPDF, setIsShowPreviewPDF] = useState(false);
  const [isCloseProjectModalVisible, setIsCloseProjectModalVisible] = useState(false);
  const [isCreatingSubProject, setIsCreatingSubProject] = useState(false);
  useEffect(() => {
    if (isUpdateSuccess) {
      message.success('Updated project');
      Router.reload();
    }
  }, [isUpdateSuccess]);
  const clickCreateSubProject = async () => {
    if (createSubProject) {
      setIsCreatingSubProject(prevState => !prevState);
      createSubProject().catch(e => {
        console.error(e);
        message.error(`${e.data.message}.`);
        setIsCreatingSubProject(prevState => !prevState);
      });
    }
  };
  return <Row className={cx('form d-flex justify-content-space-between', styles.container)}>
      {projectDetail?.status_display === PROJECT_STATUS_DISPLAY.CLOSED && <div className={styles.closeStatusProjectWrap}>
          <ClosedButtons>
            {!isEmpty(projectReports?.results) && <Dropdown.Button data-testid="export-pdf-button" className={cx('edit-project-dropdown', styles.editProjectButton, styles.exportToPDFButton)} onClick={() => setIsShowPreviewPDF(true)} overlay={<Menu className={cx('delete-button', styles.menuDeleteButton, {
          [styles.deleteButtonForClosedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.CLOSED,
          [styles.deleteButtonForActivatedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.ACTIVATED
        })}>
                    <MenuDeleteButton onConfirm={confirm} />
                  </Menu>} icon={<FontAwesomeIcon icon={faCaretDown} />}>
                <FontAwesomeIcon icon={faDownload} />
                EXPORT TO PDF
              </Dropdown.Button>}
            <Button type="primary" htmlType="submit" className="btn-blue" onClick={() => changeStatusToActivated(RouteRolesEnum.ADMIN, 'Are you sure you want to reactivate this project?', 'Reactivating it will restore NP access to the project', 'REACTIVATE PROJECT')}>
              Reactivate Project
            </Button>
          </ClosedButtons>
          <Modal className={styles.previewPDFModal} visible={isShowPreviewPDF} onOk={() => setIsShowPreviewPDF(false)} onCancel={() => setIsShowPreviewPDF(false)} footer={null}>
            <PreviewPDF />
          </Modal>

          <div className={cx('project-alert-close', styles.notifySpacing)}>
            {`This project is now closed. You will have until
             ${formatClosedDate(projectDetail.closed_date)} to access your
            reports, after which they will be removed from our servers.`}
          </div>
        </div>}
      <Row>
        {createSubProject && <CopyButtons>
            {projectDetail?.status_display === PROJECT_STATUS_DISPLAY.PENDING && <div>
                <Button data-testid="pending-copy-to-sub-project" type="primary" className="btn-blue" disabled={isCreatingSubProject} loading={isCreatingSubProject} onClick={clickCreateSubProject}>
                  Copy To Sub-Project
                </Button>
              </div>}

            {projectDetail?.status_display && ![PROJECT_STATUS_DISPLAY.PENDING, PROJECT_STATUS_DISPLAY.CLOSED, PROJECT_STATUS_DISPLAY.COMPLETED].includes(projectDetail?.status_display) && <div>
                  <Popconfirm title={`Project is in ${projectDetail?.status_display} state. Are you sure you want to copy to sub-project?`} onConfirm={clickCreateSubProject} okText="Yes" cancelText="No">
                    <Button data-testid="non-pending-copy-to-sub-project" type="primary" className="btn-blue" disabled={isCreatingSubProject} loading={isCreatingSubProject}>
                      Copy To Sub-Project
                    </Button>
                  </Popconfirm>
                </div>}
            <div>
              <Button data-testid="accounting-button" type="primary" className="btn-blue" disabled={projectDetail.final_price === '0' && projectDetail.partner_price === '0'} onClick={showAccountingModal}>
                Accounting
              </Button>
            </div>
          </CopyButtons>}
        {}
      </Row>

      {projectDetail?.status_display === PROJECT_STATUS_DISPLAY.ACTIVATED && projectReports?.count === 0 && <div className={styles.closeStatusProjectWrap}>
            <Popconfirm title="Project doesn't have the report. Are you sure you want to complete this project?" onConfirm={() => {
        adminProjectDetailStore.completeProject(projectDetail.id);
      }} okText="Yes" cancelText="No">
              <Dropdown.Button className={cx('edit-project-dropdown', styles.editProjectButton, styles.completeButton)} overlay={<MenuCloseButton onConfirm={() => {
          adminProjectDetailStore.closeProject(projectDetail.id);
        }} />} icon={<FontAwesomeIcon icon={faCaretDown} />}>
                {!isLoading ? <>
                    <CheckIcon /> Complete
                  </> : <ClipLoader size={14} color="#FFFFFF" />}
              </Dropdown.Button>
            </Popconfirm>
            <Dropdown.Button data-testid="edit-project-button" className={cx('edit-project-dropdown', styles.editProjectButton)} onClick={showEditProjectModal} overlay={<Menu className={cx('delete-button', styles.menuDeleteButton, {
        [styles.deleteButtonForClosedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.CLOSED,
        [styles.deleteButtonForActivatedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.ACTIVATED
      })}>
                  <MenuDeleteButton onConfirm={confirm} />
                </Menu>} icon={<FontAwesomeIcon icon={faCaretDown} />}>
              <FontAwesomeIcon icon={faPen} />
              Edit Project Details
            </Dropdown.Button>
          </div>}

      {projectDetail?.status_display === PROJECT_STATUS_DISPLAY.COMPLETED && projectReports?.count >= 0 && <div className={styles.closeStatusProjectWrap}>
            <Popconfirm title="Are you sure you want to close this project?" onConfirm={() => {
        adminProjectDetailStore.closeProject(projectDetail.id);
      }} okText="Yes" cancelText="No">
              <Dropdown.Button className={cx('edit-project-dropdown', styles.editProjectButton, styles.completeButton)} overlay={<MenuCloseButton onConfirm={() => {
          adminProjectDetailStore.closeProject(projectDetail.id);
        }} />} icon={<FontAwesomeIcon icon={faCaretDown} />}>
                {!isLoading ? <>
                    <CheckIcon /> Close project
                  </> : <ClipLoader size={14} color="#FFFFFF" />}
              </Dropdown.Button>
            </Popconfirm>
            <Dropdown.Button data-testid="edit-project-button" className={cx('edit-project-dropdown', styles.editProjectButton)} onClick={showEditProjectModal} overlay={<Menu className={cx('delete-button', styles.menuDeleteButton, {
        [styles.deleteButtonForClosedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.CLOSED,
        [styles.deleteButtonForActivatedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.ACTIVATED
      })}>
                  <MenuDeleteButton onConfirm={confirm} />
                </Menu>} icon={<FontAwesomeIcon icon={faCaretDown} />}>
              <FontAwesomeIcon icon={faPen} />
              Edit Project Details
            </Dropdown.Button>
          </div>}

      {projectDetail?.status_display === PROJECT_STATUS_DISPLAY.ACTIVATED && projectReports?.count > 0 && <div className={styles.closeStatusProjectWrap}>
            <Dropdown.Button className={cx('edit-project-dropdown', styles.editProjectButton, styles.completeButton)} onClick={() => {
        adminProjectDetailStore.completeProject(projectDetail.id);
      }} overlay={<MenuCloseButton onConfirm={() => {
        adminProjectDetailStore.closeProject(projectDetail.id);
      }} />} icon={<FontAwesomeIcon icon={faCaretDown} />}>
              {!isLoading ? <>
                  <CheckIcon /> Complete
                </> : <ClipLoader size={14} color="#FFFFFF" />}
            </Dropdown.Button>
          </div>}

      {[PROJECT_STATUS_DISPLAY.MATCHED, PROJECT_STATUS_DISPLAY.PENDING, PROJECT_STATUS_DISPLAY.SCOPING].includes(projectDetail?.status_display) && <>
          <Dropdown.Button data-testid="edit-project-button" className={cx('edit-project-dropdown', styles.editProjectButton)} onClick={showEditProjectModal} icon={<FontAwesomeIcon icon={faCaretDown} />} overlay={<Menu className={cx('delete-button', styles.menuDeleteButton, {
        [styles.deleteButtonForClosedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.CLOSED,
        [styles.deleteButtonForActivatedProject]: projectDetail?.status_display === PROJECT_STATUS_DISPLAY.ACTIVATED
      })}>
                <Menu.Item onClick={() => setIsCloseProjectModalVisible(true)}>
                  <span className={styles.deleteButton}>
                    <FontAwesomeIcon className={styles.deleteIcon} icon={faLock} />
                    Close Project
                  </span>
                </Menu.Item>
                <MenuDeleteButton onConfirm={confirm} />
              </Menu>}>
            <FontAwesomeIcon icon={faPen} />
            Edit Project Details
          </Dropdown.Button>
          <CloseProjectModal visible={isCloseProjectModalVisible} closeModal={() => setIsCloseProjectModalVisible(false)} changeProjectStatus={changeProjectStatus} projectDetail={projectDetail} />
          {projectDetail?.status_display === PROJECT_STATUS_DISPLAY.SCOPING && <Button type="primary" htmlType="submit" className="btn-blue" onClick={() => changeStatusToActivated(RouteRolesEnum.ADMIN)}>
              Activate Project
            </Button>}
        </>}
    </Row>;
};
export default observer(ActionButtons);